import {
  Button,
  Drawer,
  DrawerBody,
  DrawerCloseButton,
  DrawerContent,
  DrawerFooter,
  DrawerHeader,
  DrawerOverlay,
  useDisclosure,
} from '@chakra-ui/react';
import { rem } from 'polished';
import { FC, PropsWithChildren } from 'react';

import { FilterIcon } from '@sphere/icons';
import { useUITranslation } from '../../context/TranslationProvider';

type Props = PropsWithChildren & {
  title?: string;
};

export const FilterDrawer: FC<Props> = ({ title, children }) => {
  const { t } = useUITranslation();
  const { isOpen, onOpen, onClose } = useDisclosure();

  return (
    <>
      <Button
        variant="secondary"
        rounded="radius.8"
        px="space.16"
        py="space.4"
        width="100%"
        onClick={onOpen}
        justifyContent="space-between"
        rightIcon={<FilterIcon boxSize={rem(20)} />}
      >
        {title || t('common.drawers.sort-and-filter.trigger-button.label')}
      </Button>
      <Drawer isOpen={isOpen} onClose={onClose} placement="bottom">
        <DrawerOverlay
          background="rgba(34, 34, 34, 0.4)"
          backdropFilter="auto"
          backdropBlur={rem(4)}
        />
        <DrawerContent bg="blackBg" roundedTop="radius.12" h={`calc(100dvh - ${rem(80)})`}>
          <DrawerCloseButton size="lg" />
          <DrawerHeader mt="space.16" mb="space.8" fontWeight="200" fontSize="2xl">
            {title || t('common.drawers.sort-and-filter.trigger-button.label')}
          </DrawerHeader>

          <DrawerBody>{children}</DrawerBody>

          <DrawerFooter boxShadow="0px -10px 40px rgba(0, 0, 0, 0.1)" borderTopRadius="radius.12">
            <Button width="100%" onClick={onClose}>
              {t('common.drawers.sort-and-filter.apply-button.label')}
            </Button>
          </DrawerFooter>
        </DrawerContent>
      </Drawer>
    </>
  );
};
